// Copyright (c) 2021 Sendanor. All rights reserved.

// For development, there is also REACT_APP_PROXY_API_URL and REACT_APP_PROXY_VIDEO_URL.
// Look at src/setupProxy.js.

export const PUBLIC_URL    : string = process?.env?.REACT_APP_PUBLIC_URL   ?? 'http://localhost:3000';
export const LIVE_API_URL  : string = process?.env?.REACT_APP_LIVE_API_URL ?? '/api';
export const CHAT_URL      : string = process?.env?.REACT_APP_CHAT_URL     ?? 'https://www.viesti.app?h=0';
export const AD_TITLE      : string = process?.env?.REACT_APP_AD_TITLE     ?? 'Hangover Games';
export const AD_URL        : string = process?.env?.REACT_APP_AD_URL       ?? 'https://hangover.games/r.html';

export const LIVE_STREAM_URL         : string = process?.env?.REACT_APP_LIVE_STREAM_URL         ?? PUBLIC_URL;
export const LIVE_STREAM_PATH_PREFIX : string = process?.env?.REACT_APP_LIVE_STREAM_PATH_PREFIX ?? '/tv/';
export const LIVE_STREAM_PATH_SUFFIX : string = process?.env?.REACT_APP_LIVE_STREAM_PATH_SUFFIX ?? '/index.mpd';

export const FEED_URL = (feedName: string) => `${LIVE_STREAM_URL}${LIVE_STREAM_PATH_PREFIX}${encodeURIComponent(feedName)}${LIVE_STREAM_PATH_SUFFIX}`;
